enum FormFields {
  MIN_DONATION = 'minDonation',
  MAX_DONATION = 'maxDonation',
  TYPE = 'type',
  TASK_TITLE = 'taskTitle',
  TASK_NOTES = 'taskNotes',
  TASK_ASSIGNEE = 'taskAssignee',
  TASK_DUE_DATE = 'taskDueDate',
  LABEL_TARGET = 'labelTarget',
}

export default FormFields;
